module.exports = __webpack_public_path__ + "img/1820563-84-5.c849cebe.png";